export default "/wrap-nfts.09488846e4e242d32347abfa91f23a2d.png";